import React, { useEffect, useRef, useState } from 'react';
import {
  formatDateParts,
  getRecordStatusClass,
  buildQueryString,
  canMarkRegularization,
  isFutureRecordDate,
} from '../darwinRecordUtils';

const DarwinRecordCard = ({ item, baseUrl, history }) => {
  const { dd, mmm, ddd } = formatDateParts(item.dateStr, item.day, item.month);
  const statusClass = getRecordStatusClass(item.status);
  const showActions = !isFutureRecordDate(item.dateStr);
  const showMarkRegularization = canMarkRegularization(item.dateStr);
  const [menuOpen, setMenuOpen] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const handleClickOutside = (event) => {
      if (cardRef.current && !cardRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [menuOpen]);

  const navigate = (path) => {
    setMenuOpen(false);
    history.push(`${baseUrl}${path}`);
  };

  const dailyActivitiesPath = buildQueryString({
    date: item.dateStr,
    status: item.status,
  });

  const regularizePath = buildQueryString({
    date: item.dateStr,
  });

  return (
    <article
      ref={cardRef}
      className={`darwin-record-card ${menuOpen ? 'darwin-record-card--menu-open' : ''} ${
        showActions ? '' : 'darwin-record-card--no-actions'
      }`}
    >
      <div className="darwin-record-card__body">
        <div className="darwin-record-card__date">
          <span className="darwin-record-card__date-day">{dd}</span>
          <span className="darwin-record-card__date-month">{mmm}</span>
          <span className="darwin-record-card__date-weekday">{ddd}</span>
        </div>
        <div className="darwin-record-card__content">
          <p className={`darwin-record-card__status ${statusClass}`}>
            {item.status}
            {item.holidayName ? (
              <span className="darwin-status-present"> ({item.holidayName})</span>
            ) : null}
          </p>
          <p className="darwin-record-card__timing">
            <span className="darwin-record-card__timing-label">Timing: </span>
            <span className="darwin-record-card__timing-value">
              {item.checkIn || 'N/A'} → {item.checkOut || 'N/A'}
            </span>
          </p>
          {item.isSyncStr ? (
            <p className="darwin-record-card__sync">{item.isSyncStr}</p>
          ) : null}
        </div>
      </div>

      {showActions ? (
        <div className="darwin-record-card__actions">
          <button
            type="button"
            className="darwin-record-card__menu-btn"
            aria-label="Open attendance actions"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((prev) => !prev)}
          >
            <span className="darwin-record-card__menu-icon">⋮</span>
          </button>

          {menuOpen ? (
            <div className="darwin-record-card__menu" role="menu">
              <button
                type="button"
                role="menuitem"
                className="darwin-record-card__menu-item"
                onClick={() =>
                  navigate(`/darwin-record/daily-activities${dailyActivitiesPath}`)
                }
              >
                View Details
              </button>
              {showMarkRegularization ? (
                <button
                  type="button"
                  role="menuitem"
                  className="darwin-record-card__menu-item"
                  onClick={() => navigate(`/darwin-record/regularize${regularizePath}`)}
                >
                  Mark regularization
                </button>
              ) : null}
            </div>
          ) : null}
        </div>
      ) : null}
    </article>
  );
};

export default DarwinRecordCard;
